export default "__VITE_ASSET__BECFjGLO__"